var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM4.3025 12.71C4.625 12.035 6.59 11.375 8 11.375C9.41 11.375 11.3825 12.035 11.6975 12.71C10.6775 13.52 9.395 14 8 14C6.605 14 5.3225 13.52 4.3025 12.71ZM12.77 11.6225C11.6975 10.3175 9.095 9.875 8 9.875C6.905 9.875 4.3025 10.3175 3.23 11.6225C2.465 10.6175 2 9.365 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 9.365 13.535 10.6175 12.77 11.6225ZM8 3.5C6.545 3.5 5.375 4.67 5.375 6.125C5.375 7.58 6.545 8.75 8 8.75C9.455 8.75 10.625 7.58 10.625 6.125C10.625 4.67 9.455 3.5 8 3.5ZM8 7.25C7.3775 7.25 6.875 6.7475 6.875 6.125C6.875 5.5025 7.3775 5 8 5C8.6225 5 9.125 5.5025 9.125 6.125C9.125 6.7475 8.6225 7.25 8 7.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.dcd3c922d071196c197c7a04c7231e00.svg";
export { ForwardRef as ReactComponent };